import {
  SET_ORGANIZATION,
  SET_ORGANIZATION_DOCUMENTS,
  SET_ORGANIZATION_SETTINGS,
} from '~/store/organizations/mutation-types';

export default {
  [SET_ORGANIZATION](state, payload) {
    state.organization = payload;
  },
  [SET_ORGANIZATION_DOCUMENTS](state, payload) {
    state.documents = payload;
  },
  [SET_ORGANIZATION_SETTINGS](state, payload) {
    state.settings = payload;
  },
};
